import html from "../assets/html.png";
import css from "../assets/css.png";
import JavaScript from "../assets/javascript.png";
import ReactImg from "../assets/react.png";
import Node from "../assets/node.png";
import Tailwind from "../assets/tailwind.png";
import java from "../assets/java.png";
import springBoot from "../assets/springboot.png";

export const skills = [
  {
    id: 1,
    src: html,
    title: "HTML",
    style: "shadow-orange-500",
  },
  {
    id: 2,
    src: css,
    title: "CSS",
    style: "shadow-blue-500",
  },
  {
    id: 3,
    src: JavaScript,
    title: "JAVASCRIPT",
    style: "shadow-yellow-500",
  },
  {
    id: 4,
    src: ReactImg,
    title: "REACT",
    style: "shadow-blue-600",
  },
  {
    id: 5,
    src: java,
    title: "JAVA",
    style: "shadow-orange-500",
  },
  {
    id: 6,
    src: springBoot,
    title: "SPRING BOOT",
    style: "shadow-green-500",
  },
  {
    id: 7,
    src: Tailwind,
    title: "TAILWIND",
    style: "shadow-orange-500",
  },

  {
    id: 8,
    src: Node,
    title: "NODE JS",
    style: "shadow-green-500",
  },
];
